<template><section><template>
<h3>Checkbox</h3>
<div class="bs-docs-section">
<div class="bs-example">
<h4>Checkbox</h4>
<n3-checkbox label="single">single</n3-checkbox>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"single"</span>&gt;</span>single<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox</span>&gt;</span>
</code></pre>
<hr>
<n3-checkbox-group v-model="checkboxValue">
  <n3-checkbox-btn label="left" disabled>Left</n3-checkbox-btn>
  <n3-checkbox-btn label="middle">Middle</n3-checkbox-btn>
  <n3-checkbox-btn label="right">Right</n3-checkbox-btn>
</n3-checkbox-group>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox-group</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"checkboxValue"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox-btn</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"left"</span> <span class="hljs-attr">disabled</span>&gt;</span>Left<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox-btn</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox-btn</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"middle"</span>&gt;</span>Middle<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox-btn</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox-btn</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"right"</span>&gt;</span>Right<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox-btn</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox-group</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-js">{
  <span class="hljs-attr">checkboxValue</span>: [<span class="hljs-string">'middle'</span>]
}
</code></pre>
<n3-checkbox-group v-model="checkboxValue">
  <n3-checkbox label="left" disabled>Left</n3-checkbox>
  <n3-checkbox label="middle">Middle</n3-checkbox>
  <n3-checkbox label="right">Right</n3-checkbox>
</n3-checkbox-group>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox-group</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"checkboxValue"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"left"</span> <span class="hljs-attr">disabled</span>&gt;</span>Left<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"middle"</span>&gt;</span>Middle<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-checkbox</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"right"</span>&gt;</span>Right<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-checkbox-group</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-js">{
  <span class="hljs-attr">checkboxValue</span>: [<span class="hljs-string">'middle'</span>]
}
</code></pre>
<h3>Group Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>options</td>
<td><code v-pre="">Array</code></td>
<td>-</td>
<td>options</td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">radio</code></td>
<td><code v-pre="">radio</code>,<code v-pre="">button</code> work with <code v-pre="">options</code></td>
</tr>
</tbody>
</table>
<h3>Group Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>change</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<h3>Checkbox Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td>false</td>
<td>disabled</td>
</tr>
</tbody>
</table>
<h3>Checkbox Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>change</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</div></template>

</section></template>

<script>
export default {
  data () {
    return {
      single: false,
      checkboxValue: ['middle']
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3CheckboxDocs.md?c0f6729c